import React from "react";
import ArchiveMapeProcesa from "../../components/admin/archiveMapeProcesa";

function ArchiveMapeProcesaPage(props) {
  return (
    <div className="admin-page-child-wrapper">
      <ArchiveMapeProcesa />
    </div>
  );
}

export default ArchiveMapeProcesaPage;
